module.exports = __webpack_public_path__ + "img/google-play-btn.8ae308af.png";